import { useRef, useState } from "react";
import { apiUrl } from "../../functions"; 
import Input from "../common/Input";
import { Page } from "../types/Types";

interface GameOverProps {
  gridOrig: string[][];
  grid: string[][];
  mode: string;
  scoreSubmitted: boolean;
  move: number;
  remainingMoves: number;
  setMove: (move: number) => void;
  setGrid: (grid: string[][]) => void;
  setCurrentPage: (currentPage: Page) => void;
  setScoreSubmitted: (scoreSubmitted: boolean) => void;
  updateScore: () => void;
}


const GameOver: React.FC<GameOverProps> = ({
  grid,
  mode,
  scoreSubmitted,
  gridOrig,
  move,
  remainingMoves,
  setMove,
  setGrid,
  setCurrentPage,
  setScoreSubmitted,
  updateScore
}) => {
  const [localUserName, setLocalUserName] = useState(localStorage.getItem('userName'));

  const inputElement = useRef<HTMLInputElement>(null);

  const updateScores = () => {
    var sendName = localUserName;
    if (inputElement.current) {
      localStorage.setItem('userName', inputElement.current.value);
      setLocalUserName(inputElement.current.value)
      sendName = inputElement.current.value;
    }

    var browserID = localStorage.getItem("browserID");

    fetch(apiUrl() + `/api/update-static-scores?name=${sendName}&score=${move}&browserID=${browserID}`)
      .then(() => {
        setScoreSubmitted(true);
      }).then(() => {
        updateScore();
      })
  }

  return (
    <div className="fixed left-0 top-0 text-bold bg-neutral-500/70 w-full h-full">
      <div className="flex flex-col w-full h-full justify-center items-center">
        <div className="text-white text-4xl">Well done!</div>
        {mode === 'daily' && (
          <>
            {!scoreSubmitted && (
              <>
                <div className="flex my-10">
                  <div className="w-[130px]">
                    {(!localUserName) && (
                      <Input inputElement={inputElement} id="name" label="Name" />
                    )}
                    {localUserName && (
                      <>
                        <div className="rounded rounded-r-none bg-gray-300 py-2 pl-3 border-2 border-gray-600">{localUserName}</div>
                        <span className="cursor-pointer underline italic" onClick={() => { localStorage.removeItem('userName'); setLocalUserName('') }}>change name</span>
                      </>
                    )}

                  </div>
                  <button className="h-[44px] rounded-l-none w-[130px] bg-gray-600 rounded p-3 font-bold text-white" onClick={updateScores}>Submit score</button>
                </div>
              </>
            )}
            {scoreSubmitted && (
              <div className="text-white">Your score has been submitted.</div>
            )}

          </>
        )}
        <div className="flex gap-3  ">
          <button onClick={() => { setMove(0); setGrid(gridOrig); setScoreSubmitted(false) }} className='bg-cl-a px-5 py-3 rounded-xl  font-extrabold mt-3'>
            Play again
          </button>
          <button onClick={() => { setCurrentPage('home'); setScoreSubmitted(false) }} className='bg-cl-b px-5 py-3 rounded-xl  font-extrabold mt-3'>
            Home
          </button>
        </div>
      </div>
    </div>
  );
}
 
export default GameOver;
